/**
 * Constants for the Table component.
 */

/** Width of the expand column in pixels */
export const EXPAND_COLUMN_WIDTH = 56;

/** Width of the bulk selection column in pixels */
export const BULK_SELECTION_COLUMN_WIDTH = 32;

/** Number of skeleton rows to show during loading */
export const LOADING_SKELETON_ROWS = 20;

/** Height of the resize indicator line in pixels */
export const RESIZE_LINE_HEIGHT = 500;

/** Default column width when not specified */
export const DEFAULT_COLUMN_WIDTH = 150;

/** Key suffix for merge-by column identification */
export const MERGE_KEY_SUFFIX = 'mergeBy';
